import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTable } from '@angular/material/table';
import { MatTableDataSource } from '@angular/material/table';
import { takeUntil } from 'rxjs/operators';
import { CheckedInService } from 'src/app/users/services/checked-in.service';
import { JwtService } from 'src/app/core/services/jwt.service';
import { GlobalService } from 'src/app/core/services/global.service';
import { Router } from '@angular/router';
import { MasterService } from '../../services/master.service';

@Component({
  selector: 'app-payment-success-page',
  templateUrl: './payment-success-page.component.html',
  styleUrls: ['./payment-success-page.component.scss'],
})
export class PaymentSuccessPageComponent implements OnInit {
  public success = true;
  constructor(
    private globalService: GlobalService,
    private checkedInService: CheckedInService,
    private masterService: MasterService,
    private router: Router
  ) {}
  public transactionDate = '';
  public continue = false;
  public cartItems = [];
  public serviceType;
  public logo = '';
  public parameters;
  ngOnInit() {
    const today = new Date();
    const date = today.getDate();
    const year = today.getFullYear();
    const month = today.toLocaleString('default', { month: 'short' });
    const time = today.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
    });
    this.transactionDate = `${date} ${month}, ${year}`;
    this.cartItems = JSON.parse(localStorage.getItem('serviceCartItems'));
    if (window.localStorage['ServiceType']) {
      this.serviceType = window.localStorage['ServiceType'];
    }
    this.getlogo();
    const currentUrl = window.location.href;
    let paramaters = new URL(currentUrl).searchParams;
    this.parameters = paramaters;
    const worldLine = paramaters.get('hostedCheckoutId');
    if (worldLine) {
      this.worldLineStatus();
      return;
    }
    if (currentUrl.length > 200) {
      this.urlBillingInfo(currentUrl);
    } else {
      this.continue = true;
    }
    localStorage.removeItem('serviceCartItems');
    localStorage.removeItem('serviceName');
    localStorage.removeItem('ServiceType');
    localStorage.removeItem('serviceNameId');
    //serviceCartItems serviceName ServiceType serviceNameId
  }
  worldLineStatus() {
    this.globalService.showLoader = true;
    const data = {
      HostedCheckoutId: this.parameters.get('hostedCheckoutId'),
      // paymentMethodeId
    };
    this.masterService
      .getHostedCheckoutStatus(data)
      .pipe(takeUntil(this.globalService.componentDestroyed(this)))
      .subscribe(
        (response) => {
          // if(response.Data.length > 0){

          // }
          if (response.Data) {
            const paymentData = response.Data;
            const responses = response.Data;
            const paymentStatus = responses.PaymentStatus;
            this.success =
              paymentStatus == 'CAPTURED' ||
              'PAID' ||
              'COMPLETED' ||
              'PENDING_CAPTURE'
                ? true
                : false;
            this.globalService.showLoader = false;
          } else {
            this.globalService.showLoader = false;
          }
        },
        (error) => {
          this.globalService.showLoader = false;
          this.success = false;
          this.globalService.handleApiError(error);
        }
      );
  }
  urlBillingInfo(url) {
    let paramaters = new URL(url).searchParams;
    const amount = paramaters.get('amount');
    const currency = paramaters.get('currency');
    const paymentBy = paramaters.get('paymentBy');
    const Items = this.cartItems;
    const BookingUserId = paramaters.get('BookingUserId');
    const ServiceId = paramaters.get('ServiceId');
    const ServiceType = paramaters.get('ServiceType');
    const RequestType = 'service';
    const guestName = paramaters.get('guestName');
    const Message = paramaters.get('Message');
    const HotelId = paramaters.get('HotelId');
    const PayerID = paramaters.get('PayerID');
    const paymentId = paramaters.get('paymentId');
    const ServiceDateFrom = paramaters.get('ServiceDateFrom');
    const ServiceDateTo = paramaters.get('ServiceDateTo');
    const ServiceTimeFrom = paramaters.get('ServiceTimeFrom');
    const ServiceTimeTo = paramaters.get('ServiceTimeTo');
    const DepartmentId = paramaters.get('DepartmentId');
    const TaxCountryId = paramaters.get('TaxCountryId');
     let GuestAddress = paramaters.get('BillingAddress');
    let addressData;

    try {
      const unescapedJson = GuestAddress.replace(/\\"/g, '"');
      addressData = JSON.parse(unescapedJson);
      GuestAddress = addressData;
    } catch (error) {
      console.error('Error parsing GuestAddress:', error);
    }
    if (paymentBy != 'stripe') {
      const data = {
        amount: amount,
        currency: currency,
        BookingUserId: BookingUserId,
        HotelId: HotelId,
        Items: Items,
        RequestType: RequestType,
        ServiceDateFrom: ServiceDateFrom,
        ServiceDateTo: ServiceDateTo,
        ServiceId: ServiceId,
        BillingAddress: GuestAddress,
        ServiceType: ServiceType,
        ServiceTimeFrom: ServiceTimeFrom,
        ServiceTimeTo: ServiceTimeTo,
        guestName: guestName,
        Message: Message,
        PayerID: PayerID,
        paymentId: paymentId,
        DepartmentId: DepartmentId,
        TaxCountryId: TaxCountryId,
      };
      this.checkedInService
        .urlBillingInfo(data)
        .pipe(takeUntil(this.globalService.componentDestroyed(this)))
        .subscribe(
          (response) => {
            this.router.navigate(['/guest/payment/success']);
            this.globalService.showLoader = true;
            localStorage.removeItem('serviceCartItems');
            this.continue = true;
          },
          (error) => {
            this.globalService.showLoader = false;
            this.globalService.handleApiError(error);
          }
        );
    }
  }

  billing() {
    if (this.serviceType) {
      this.router.navigate(['hotel-services']);
    } else {
      this.router.navigate(['/guest/billing-history']);
    }
  }

  getlogo() {
    if (window.localStorage['Logo']) {
      this.logo = window.localStorage.getItem('Logo');
    }
  }

  GoToResturantPage() {
    this.router.navigate(['hotel-services']);
  }

  ngOnDestroy() {}
}
